import { render, staticRenderFns } from "./PaymentHome.vue?vue&type=template&id=8810d6ea"
import script from "./PaymentHome.vue?vue&type=script&lang=js"
export * from "./PaymentHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports